import React, { useEffect, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, Image, Toast } from "antd-mobile";
import FixedNavBar from "@/components/fixedNavBar";
import { AddCircleOutline } from "antd-mobile-icons";
import useRouter from "@/hooks/useRouter";
import usePopup from "@/hooks/usePopup";
import Plan from "./comp/Plan";
import API from "@/api";
import { showGlobalLoading } from "@/components/globalLoading";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import { getUserInfoMethod } from "@/redux/reducers/authSlice";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";

const evolutionDefaultValue = "-1";
const ManagePlan: React.FC = () => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { location } = useRouter();
	const { showLoading, hideLoading } = showGlobalLoading();
	const { userInfo } = useSelector((state: RootState) => state.auth);
	const PlanPopup = usePopup();
	const [operateDelState, setOperateDelState] = useState(true);
	const [dataList, setDataList] = useState<Record<string, any>>({});
	const [evolutionData, setEvolutionData] = useState<Record<string, any>>({});
	const [evolutionSelected, setEvolutionSelected] = useState(
		evolutionDefaultValue
	);
	const [defautlValue, setDefautlValue] = useState(false);
	const [userData, setUserData] = useState<Record<string, any>>({});

	const onSubmitHandle = async (params: {}) => {
		try {
			showLoading();
			const result: any = await API.members.postUserWaterPlanOperation(
				params
			);
			if (result?.code === 0) {
				Toast.show({
					content: t("UpdateCompleted"),
					position: "top",
				});
				dispatch(getUserInfoMethod());
			}
		} catch (error) {
			console.log("---postUserWaterPlanOperation--:", error);
		} finally {
			hideLoading();
			PlanPopup.closePopup();
		}
	};

	const onSelectedHandle = async (value: string) => {
		try {
			showLoading();
			const params: any = {
				planTime: value,
				id: userData.uid,
			};
			if (defautlValue) {
				delete params["id"];
			}
			const result: any = await API.members.postUserAgentInviteRemake(
				params
			);
			if (result?.code === 0) {
				Toast.show({
					content: t("UpdateCompleted"),
					position: "top",
				});
			}
		} catch (error) {
			console.log("---postUserAgentInviteRemake--:", error);
		} finally {
			hideLoading();
		}
		setEvolutionSelected(value);
	};

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const paramDefault = searchParams.get("default");
		const paramUser = searchParams.get("user");
		// setDefautlValue(Boolean(paramDefault));
		paramDefault && setEvolutionSelected(paramDefault);
		if (!isEmpty(paramUser) && paramUser) {
			const parseUser = JSON.parse(paramUser);
			setUserData(parseUser);
			parseUser.time && setEvolutionSelected(parseUser.time);
		}
		dispatch(getUserInfoMethod());
	}, []);

	useEffect(() => {
		setDataList(userInfo?.waterPlan ?? {});
	}, [userInfo]);

	return (
		<div className="router-main">
			<FixedNavBar
				title={t("ManagePlan")}
				replacePage="/members"
				rightContent={[
					<div
						style={{ display: "flex", justifyContent: "flex-end" }}
						key={"manage"}
					>
						<Image
							onClick={() => setOperateDelState(false)}
							src={require("@/assets/images/icons/del.png")}
							width={24}
							height={24}
							key={"del"}
							style={{
								display: operateDelState ? "block" : "none",
							}}
						/>
						<Image
							onClick={() => setOperateDelState(true)}
							src={require("@/assets/images/icons/tick.png")}
							width={24}
							height={24}
							key={"tick"}
							style={{
								display: !operateDelState ? "block" : "none",
							}}
						/>
					</div>,
				]}
			/>
			<div className="router-view" style={{ paddingTop: pxToRem(15) }}>
				<div className={classes.alisonBox}>
					<Image
						src={require("@/assets/images/icons/Alison.png")}
						width={48}
						height={48}
					/>
					<p>{t("DefaultPlan")}</p>
					<div className="operates">
						<div
							style={{
								display: "flex",
								alignItems: "center",
							}}
						>
							<Image
								onClick={() => {
									setDefautlValue(true);
									setEvolutionData({});
									PlanPopup.showPopup();
								}}
								src={require("@/assets/images/icons/omit.png")}
								width={24}
								height={24}
							/>

							{evolutionSelected === evolutionDefaultValue ? (
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										minWidth: pxToRem(66),
										marginLeft: pxToRem(10),
									}}
								>
									<Image
										src={require("@/assets/images/icons/tick.png")}
										width={24}
										height={24}
									/>
								</div>
							) : (
								<Button
									onClick={() =>
										onSelectedHandle(evolutionDefaultValue)
									}
									size="small"
									style={{
										color: "#FFFFFF",
										"--text-color": "#FFFFFF",
										"--background-color": "#4C66C7",
										"--border-width": "0",
										marginLeft: pxToRem(10),
									}}
								>
									{t("Select")}
								</Button>
							)}
						</div>
					</div>
				</div>
				{Object.keys(dataList).map((key, index) => {
					const item = JSON.parse(dataList[key]);
					if (key === "-1") return null;
					return (
						<div className={classes.alisonBox} key={index}>
							<Image
								src={require("@/assets/images/icons/Alison.png")}
								width={48}
								height={48}
							/>
							<p>
								{t("Plan")} {index + 1}
							</p>
							<div className="operates">
								{!operateDelState ? (
									<span
										onClick={() => {
											onSubmitHandle({
												time: key,
											});
										}}
										className="del"
									>
										{t("Delete")}
									</span>
								) : (
									<div
										style={{
											display: "flex",
											alignItems: "center",
										}}
									>
										<Image
											onClick={() => {
												setDefautlValue(false);
												setEvolutionData(item);
												PlanPopup.showPopup();
											}}
											src={require("@/assets/images/icons/omit.png")}
											width={24}
											height={24}
										/>
										{evolutionSelected === key ? (
											<div
												style={{
													display: "flex",
													justifyContent: "center",
													minWidth: pxToRem(66),
													marginLeft: pxToRem(10),
												}}
											>
												<Image
													src={require("@/assets/images/icons/tick.png")}
													width={24}
													height={24}
												/>
											</div>
										) : (
											<Button
												onClick={() =>
													onSelectedHandle(key)
												}
												size="small"
												style={{
													color: "#FFFFFF",
													"--text-color": "#FFFFFF",
													"--background-color":
														"#4C66C7",
													"--border-width": "0",
													marginLeft: pxToRem(10),
												}}
											>
												{t("Select")}
											</Button>
										)}
									</div>
								)}
							</div>
						</div>
					);
				})}
				<div
					onClick={() => {
						setDefautlValue(false);
						setEvolutionData({});
						PlanPopup.showPopup();
					}}
					className={classes.addMembers}
				>
					<AddCircleOutline fontSize={34} color="#4C66C7" />
					<p>{t("AddPlan")}</p>
				</div>
			</div>

			<PlanPopup.PopupComp
				visible={PlanPopup.visiblePopup}
				onClose={PlanPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					PlanPopup.closePopup();
				}}
			>
				{PlanPopup.visiblePopup && (
					<Plan
						unauthorized={defautlValue}
						evolutionData={evolutionData}
						onVisiblePopup={PlanPopup.closePopup}
						onSubmit={onSubmitHandle}
					/>
				)}
			</PlanPopup.PopupComp>
		</div>
	);
};

export default ManagePlan;

const useStyles = createUseStyles({
	alisonBox: {
		display: "flex",
		alignItems: "center",
		height: pxToRem(72),
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		border: "1px solid #2F3A62",
		"& p": {
			flex: 1,
			overflow: "hidden",
			color: "#FFFFFF",
			fontSize: pxToRem(16),
			fontWeight: "500",
			paddingLeft: pxToRem(26),
		},
		"& .operates": {
			"& span.del": {
				color: "#FF6161",
				fontSize: pxToRem(16),
				fontWeight: "500",
			},
		},
	},
	addMembers: {
		display: "flex",
		alignItems: "center",
		height: pxToRem(72),
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
		border: "1px solid #2F3A62",
		"& p": {
			flex: 1,
			overflow: "hidden",
			color: "#4C66C7",
			fontSize: pxToRem(16),
			fontWeight: "500",
			paddingLeft: pxToRem(26),
		},
	},
});
